export enum AmplitudeEvents {
  LOGIN_PAGE_VIEWED = 'login_page_viewed',
  CAPTCHA_VIEWED = 'captcha_viewed',
  CAPTCHA_SOLVED = 'captcha_solved',
  LOGIN_SUBMITTED = 'login_submitted',
  LOGIN_SUCCESS = 'login_success',
  LOGIN_FAILED = 'login_failed',
  LOGIN_EMAIL_FILLED = 'login_email_filled',
  LOGIN_PASSWORD_FILLED = 'login_password_filled',
  LOGIN_FORM_INTERACTED = 'login_form_interacted',
  PROFILE_MENU_OPENED = 'profile_menu_opened',
  DASHBOARD_PAGE_VIEWED = 'dashboard_page_viewed',
  DASHBOARD_STATS_VIEWED = 'dashboard_stats_viewed',
  RECENT_ACTIVITY_LOADED = 'recent_activity_loaded',
  RECENT_ACTIVITY_ROW_CLICKED = 'recent_activity_row_clicked',
  SIDEBAR_NAVIGATION_CLICKED = 'sidebar_navigation_clicked',
  APPLICATIONS_PAGE_VIEWED = 'applications_page_viewed',
  APPLICATION_SEARCH_TYPED = 'application_search_typed',
  APPLICATION_SORT_CLICKED = 'application_sort_clicked',
  ADD_APPLICATION_CLICKED = 'add_application_clicked',
  APPLICATION_ROW_CLICKED = 'application_row_clicked',
  REPORTS_PAGE_VIEWED = 'reports_page_viewed',
  REPORTS_TAB_CLICKED = 'reports_tab_clicked',
  REPORT_ROW_CLICKED = 'report_row_clicked',
  REPORT_FILTER_DATE_SELECTED = 'report_filter_date_selected',
  REPORT_FILTER_DOC_TYPE_SELECTED = 'report_filter_doc_type_selected',
  REPORT_EXPORT_CSV_CLICKED = 'report_export_csv_clicked',
  REPORT_EXPORT_PDF_CLICKED = 'report_export_pdf_clicked',
  REPORT_EXPORT_JSON_CLICKED = 'report_export_json_clicked',
  USERS_PAGE_VIEWED = 'users_page_viewed',
  USER_ROLE_FILTER_SELECTED = 'user_role_filter_selected',
  USER_SEARCH_TYPED = 'user_search_typed',
  CREATE_USER_CLICKED = 'create_user_clicked',
  ROLES_PAGE_VIEWED = 'roles_page_viewed',
  ROLE_FILTER_SELECTED = 'role_filter_selected',
  EDIT_ROLE_CLICKED = 'edit_role_clicked',
  CREATE_ROLE_CLICKED = 'create_role_clicked',
  ROLE_CREATE_PAGE_VIEWED = 'role_create_page_viewed',
  CREATE_ROLE_SUBMIT_SUCCESS = 'create_role_submit_success',
  PERMISSION_CHECKBOX_TOGGLED = 'permission_checkbox_toggled',
  EDIT_USER_CLICKED = 'edit_user_clicked',
  REMOVE_ACCESS_CLICKED = 'remove_access_clicked',
  AUDIT_LOGS_PAGE_VIEWED = 'audit_logs_page_viewed',
  AUDIT_LOGS_CATEGORY_SELECTED = 'audit_logs_category_selected',
  AUDIT_LOGS_TIME_RANGE_SELECTED = 'audit_logs_time_range_selected',
  AUDIT_LOG_ROW_EXPANDED = 'audit_log_row_expanded',
  AUDIT_LOGS_EXPORT_FORMAT_SELECTED = 'audit_logs_export_format_selected',
  ACTIVITY_PAGE_VIEWED = 'activity_page_viewed',
  ACTIVITY_ROW_CLICKED = 'activity_row_clicked',
  APPLICATION_DETAIL_PAGE_VIEWED = 'application_detail_page_viewed',
  DOCUMENT_ROW_CLICKED = 'document_row_clicked',
  DOCUMENT_SORT_CLICKED = 'document_sort_clicked',
  ADD_DOCUMENT_CLICKED = 'add_document_clicked',
  ADD_DOCUMENT_MODAL_OPENED = 'add_document_modal_opened',
  ADD_DOCUMENT_SUBMIT_SUCCESS = 'add_document_submit_success',
  DOCUMENT_TYPE_SELECTED = 'document_type_selected',
  DOCUMENT_UPLOAD_STARTED = 'document_upload_started',
  DOCUMENT_UPLOAD_SUCCESS = 'document_upload_success',
  DOCUMENT_UPLOAD_FAILED = 'document_upload_failed',
  DOCUMENT_REVIEW_PAGE_VIEWED = 'document_review_page_viewed',
  DOCUMENT_PAGE_CHANGED = 'document_page_changed',
  APPROVE_DOCUMENT_CLICKED = 'approve_document_clicked',
  REJECT_DOCUMENT_CLICKED = 'reject_document_clicked',
  APPROVE_DOCUMENT_SUCCESS = 'approve_document_success',
  APPROVED_CLICKED = 'approved_clicked',
  APPROVED_CONFIRMED = 'approved_confirmed',
  REJECTED_CLICKED = 'rejected_clicked',
  REJECTED_CONFIRMED = 'rejected_confirmed',
  REJECT_DOCUMENT_SUBMIT_SUCCESS = 'reject_document_submit_success',
  ADD_PAGE_MODAL_OPENED = 'add_page_modal_opened',
  ADD_PAGE_FILE_SELECTED = 'add_page_file_selected',
  ADD_PAGE_UPLOAD_SUCCESS = 'add_page_upload_success',
  ADD_PAGE_UPLOAD_FAILED = 'add_page_upload_failed',
  ADD_PAGE_MODAL_CLOSED = 'add_page_modal_closed',
  EXPORT_JSON_CLICKED = 'export_json_clicked',
  EXPORT_CSV_CLICKED = 'export_csv_clicked',
  DOCUMENT_FIELDS_EXPANDED = 'document_fields_expanded',
  TRANSACTIONS_SECTION_EXPANDED = 'transactions_section_expanded',
  FRAUD_LLM_SECTION_EXPANDED = 'fraud_llm_section_expanded',
  FRAUD_METADATA_EXPANDED = 'fraud_metadata_expanded',
  NEEDS_REVIEW_CLICKED = 'needs_review_clicked',
}
